export default "__VITE_ASSET__Q$c47z$N__"